var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.41,
    height: 10.13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34 10.13L3.93 8.71l2.65-2.65H0v-2h6.58L3.93 1.41 5.34 0l5.07 5.06-5.07 5.07z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC40MSIgaGVpZ2h0PSIxMC4xMyIgZmlsbD0iIzAwNGE4NSI+CiAgICA8cGF0aCBkPSJNNS4zNCAxMC4xM0wzLjkzIDguNzFsMi42NS0yLjY1SDB2LTJoNi41OEwzLjkzIDEuNDEgNS4zNCAwbDUuMDcgNS4wNi01LjA3IDUuMDd6IiBmaWxsPSIjMDA0YTg1IiAvPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };